import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, ZALOHA_POV } from './constants';

class PovApi extends BaseApi {
	schemaUrl(tableName: string): string {
		switch (tableName) {
			case ZALOHA_POV:
				return `/${this.area}/${tableName}/Schema`;
			default:
				return super.schemaUrl(tableName);
		}
	}

	tableUrl(tableName: string): string {
		switch (tableName) {
			case ZALOHA_POV:
				return `/${this.area}/${tableName}`;
			default:
				return super.tableUrl(tableName);
		}
	}

	tableSchemaDataUrl(tableName: string): string {
		switch (tableName) {
			case ZALOHA_POV:
				return `/${this.area}/${tableName}/GetSchemaAndRows`;
			default:
				return super.tableSchemaDataUrl(tableName);
		}
	}
}

export const apiProvider = new PovApi(DMS_MODULE, NAME);
